class EthereumEventLog {
    // for example, SampleTagged(bytes32,bytes32) would be the event
    // and the arguments would be EthereumTopic("ipfsHash", IPFS_HASH),
    // EthereumTopic("tag", BYTES_32)
    constructor(event, topics, ...data) {
        this.event = event;
        this.topics = topics;
        this.data = data;
    }
}

export default EthereumEventLog;
